export class AuthInfo {

  constructor(
    public $uid:string,
    public userdisplayName:string,
    public verified:boolean,
    public verifiedDisplay: string,
    public email:string,


  ){

  }

  isLoggedIn():boolean{
    return !!this.$uid;
  }

  getdisplayName():string{
      return this.userdisplayName;
  }

  getEmailAddress():string{
      return this.email;
  }

  isVerified():boolean{
      return this.verified;
  }

  verifyDisplay(){
      let dispMessage = "";
      if (this.verified){
        dispMessage = "Verified"
      } else {
        dispMessage = "Not Verified"
      }

      return dispMessage;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/security/auth-info.ts